export default "__VITE_ASSET__BzkBsCkJ__"